// extracted by mini-css-extract-plugin
module.exports = {"root":"activities-medical-information_root__1KHAK"};